


























































import { Alert } from 'ant-design-vue'
import Vue from 'vue'
import { Component, Prop, Ref } from 'vue-property-decorator'

import { VueComponent } from '../shared/types/VueComponent'

@Component({
  props: {
    ...(Alert as any).props,
  },
})
export default class ExtendedHelpMessage extends Vue {
  @Prop() message!: string

  @Prop() items!: Record<string, string | VueComponent> | undefined

  @Prop({ type: String }) itemsTitle!: string | null

  @Prop({ type: String }) modalTitle!: string

  @Ref('alertWithHelpMessages') alertWithHelpMessages!: HTMLDivElement

  @Prop({ type: Boolean, required: false, default: false }) footerItemButtons!: boolean

  currentMessageKeyValue: string | VueComponent | null = null

  isHelpMessageModalVisible = false

  get title() {
    if (this.itemsTitle !== null) {
      return this.itemsTitle
    } else {
      return this.$t('cases_list').toString()
    }
  }

  get hasKeys() {
    return this.items && Object.keys(this.items).length > 0
  }

  // props has higher priority => need to exclude msg & description to pass html into them via slot
  get alertPropsWithoutMessageAndDescription() {
    const { message, description, ...alertProps } = this.$props

    return alertProps
  }

  onMessageClick(event: MouseEvent) {
    const target = event.target as HTMLElement

    if (target) {
      const msgKeyAttr = target.dataset['msgKey']

      if (msgKeyAttr) {
        const msgValue = this.items![msgKeyAttr]

        if (msgValue) {
          this.currentMessageKeyValue = msgValue
          this.isHelpMessageModalVisible = true
        }
      }
    }
  }

  destroyed() {
    removeEventListener('click', this.onMessageClick)
  }

  mounted() {
    if (this.hasKeys && this.alertWithHelpMessages) {
      this.alertWithHelpMessages.addEventListener('click', this.onMessageClick)
    }
  }
}
